

<template>
    <div class="fxt-favorite-heart">
        <v-icon class="fxt-favorite-heart__bg-icon" size="28px" color="white">fxt-heart-filled</v-icon>
        <v-icon size="24px" color="primary">fxt-heart-filled</v-icon>
    </div>
</template>
<script>
export default {
  methods: {},

  data() {
    return {
      loading: false,
    };
  },
};
</script>
<style scoped lang="scss">
.fxt-favorite-heart {
    position: absolute;
    top: -7px;
    right: -7px;

    &__bg-icon {
        position: absolute;
        right: -2px;
        top: -2px;
    }
}
</style>